import {
  GET_INSPECTIONS,
  GET_INSPECTIONS_SUCCESS,
  GET_INSPECTIONS_FAIL,
  GET_INSPECTION_DETAILS,
  GET_INSPECTION_DETAILS_SUCCESS,
  GET_INSPECTION_DETAILS_FAIL,
  CREATE_INSPECTION,
  CREATE_INSPECTION_SUCCESS,
  CREATE_INSPECTION_FAIL,
  UPDATE_INSPECTION,
  UPDATE_INSPECTION_SUCCESS,
  UPDATE_INSPECTION_FAIL,
  CHECK_INSPECTION_NUMBER,
  CHECK_INSPECTION_NUMBER_SUCCESS,
  CHECK_INSPECTION_NUMBER_FAIL,
  GET_INSPECTIONS_BOOKING,
  GET_INSPECTIONS_BOOKING_SUCCESS,
  GET_INSPECTIONS_BOOKING_FAIL,
  GET_INSPECTION_BOOKING_DETAILS,
  GET_INSPECTION_BOOKING_DETAILS_SUCCESS,
  GET_INSPECTION_BOOKING_DETAILS_FAIL,
  CREATE_INSPECTION_BOOKING,
  CREATE_INSPECTION_BOOKING_SUCCESS,
  CREATE_INSPECTION_BOOKING_FAIL,
  UPDATE_INSPECTION_BOOKING,
  UPDATE_INSPECTION_BOOKING_SUCCESS,
  UPDATE_INSPECTION_BOOKING_FAIL,
  DELETE_INSPECTION,
  DELETE_INSPECTION_SUCCESS,
  DELETE_INSPECTION_FAIL,
  PUT_WHATSAPP_SHARE_FAIL,
  PUT_WHATSAPP_SHARE_SUCCESS,
  PUT_WHATSAPP_SHARE,
  PUT_WHATSAPP_SHARE_PDF,
  PUT_WHATSAPP_SHARE_PDF_SUCCESS,
  PUT_WHATSAPP_SHARE_PDF_FAIL,
  RESET_INSPECTION_STATE,
} from "./actionTypes"

// Inspection - This line cannot be edited or removed
// export const getInspections = (
//   page,
//   limit,
//   searchText,
//   StaffId,
//   sortByDate
// ) => ({
//   type: GET_INSPECTIONS,
//   payload: {
//     page,
//     limit,
//     searchText,
//     StaffId,
//     sortByDate,
//   },
// })
export const getInspections = (
  page,
  limit,
  searchText,
  StaffId,
  sortByDate
) => {

  return {
    type: GET_INSPECTIONS,
    payload: { page, limit, searchText, StaffId, sortByDate },
  }
}
export const getInspectionsSuccess = inspections => ({
  type: GET_INSPECTIONS_SUCCESS,
  payload: inspections,
})

export const getInspectionsFail = error => ({
  type: GET_INSPECTIONS_FAIL,
  payload: error,
})

export const getInspectionDetails = inspectionId => ({
  type: GET_INSPECTION_DETAILS,
  payload: inspectionId,
})

export const getInspectionDetailsSuccess = inspectionDetails => ({
  type: GET_INSPECTION_DETAILS_SUCCESS,
  payload: inspectionDetails,
})

export const getInspectionDetailsFail = error => ({
  type: GET_INSPECTION_DETAILS_FAIL,
  payload: error,
})

export const createInspection = (inspection, history) => ({
  type: CREATE_INSPECTION,
  payload: { inspection, history },
})

export const createInspectionSuccess = inspection => ({
  type: CREATE_INSPECTION_SUCCESS,
  payload: inspection,
})

export const createInspectionFail = error => ({
  type: CREATE_INSPECTION_FAIL,
  payload: error,
})

export const getInspectionDetail = inspectionId => ({
  type: GET_INSPECTION_DETAILS,
  payload: inspectionId,
})
export const updateInspection = (
  inspection,
  inspectionId,
  history,
  handleCloseModal,
  setSuccess
) => {
  return {
    type: UPDATE_INSPECTION,
    payload: {
      inspection,
      inspectionId,
      history,
      handleCloseModal,
      setSuccess,
    },
  }
}

// export const updateInspection = (inspection, inspectionId, history) => ({
//   type: UPDATE_INSPECTION,
//   payload: { inspection, inspectionId, history },
// })

export const updateInspectionSuccess = inspection => ({
  type: UPDATE_INSPECTION_SUCCESS,
  payload: inspection,
})

export const updateInspectionFail = error => ({
  type: UPDATE_INSPECTION_FAIL,
  payload: error,
})

export const checkInspectionNumber = (inspectionNumber, inspectionId) => ({
  type: CHECK_INSPECTION_NUMBER,
  payload: { inspectionNumber, inspectionId },
})

export const checkInspectionNumberSuccess = inspectionNumber => ({
  type: CHECK_INSPECTION_NUMBER_SUCCESS,
  payload: { inspectionNumber },
})

export const checkInspectionNumberFail = error => ({
  type: CHECK_INSPECTION_NUMBER_FAIL,
  payload: error,
})
export const resetInspectionState = () => ({
  type: RESET_INSPECTION_STATE,
})

// BOOKING

export const getInspectionsBooking = (
  page,
  sort,
  limit,
  searchText,
  sortByDate
) => ({
  type: GET_INSPECTIONS_BOOKING,
  payload: {
    page,
    sort,
    limit,
    searchText,
    sortByDate,
  },
})

export const getInspectionsBookingSuccess = inspectionsBookings => ({
  type: GET_INSPECTIONS_BOOKING_SUCCESS,
  payload: inspectionsBookings,
})

export const getInspectionsBookingFail = error => ({
  type: GET_INSPECTIONS_BOOKING_FAIL,
  payload: error,
})

export const getInspectionBookingDetails = inspectionId => ({
  type: GET_INSPECTION_BOOKING_DETAILS,
  payload: inspectionId,
})

export const getInspectionBookingDetailsSuccess = inspectionDetails => ({
  type: GET_INSPECTION_BOOKING_DETAILS_SUCCESS,
  payload: inspectionDetails,
})

export const getInspectionBookingDetailsFail = error => ({
  type: GET_INSPECTION_BOOKING_DETAILS_FAIL,
  payload: error,
})

export const createInspectionBooking = (inspectionBooking, history) => ({
  type: CREATE_INSPECTION_BOOKING,
  payload: { inspectionBooking, history },
})

export const createInspectionBookingSuccess = inspection => ({
  type: CREATE_INSPECTION_BOOKING_SUCCESS,
  payload: inspection,
})

export const createInspectionBookingFail = error => ({
  type: CREATE_INSPECTION_BOOKING_FAIL,
  payload: error,
})

export const getInspectionBookingDetail = inspectionId => ({
  type: GET_INSPECTION_BOOKING_DETAILS,
  payload: inspectionId,
})

export const updateInspectionBooking = (
  inspectionBooking,
  inspectionBookingId,
  history
) => {

  return {
    type: UPDATE_INSPECTION_BOOKING,
    payload: { inspectionBooking, inspectionBookingId, history },
  }
}

export const updateInspectionBookingSuccess = inspection => ({
  type: UPDATE_INSPECTION_BOOKING_SUCCESS,
  payload: inspection,
})

export const updateInspectionBookingFail = error => ({
  type: UPDATE_INSPECTION_BOOKING_FAIL,
  payload: error,
})
export const deleteInspection = inspectionId => {
  return {
    type: DELETE_INSPECTION,
    payload: inspectionId,
  }
}

export const deleteInspectionSuccess = inspection => ({
  type: DELETE_INSPECTION_SUCCESS,
  payload: inspection,
})

export const deleteInspectionFail = error => ({
  type: DELETE_INSPECTION_FAIL,
  payload: error,
})

export const putWhatsappShare = (inspectionBookingId, setLoading) => ({
  type: PUT_WHATSAPP_SHARE,
  payload: { inspectionBookingId, setLoading },
})

export const putWhatsappShareSuccess = inspectionDetails => ({
  type: PUT_WHATSAPP_SHARE_SUCCESS,
  payload: inspectionDetails,
})

export const putWhatsappShareFail = error => ({
  type: PUT_WHATSAPP_SHARE_FAIL,
  payload: error,
})

export const putWhatsappSharePdf = (
  inspectionBookingId,
  setLoading,
  inspectionDetails
) => {

  return {
    type: PUT_WHATSAPP_SHARE_PDF,
    payload: { inspectionBookingId, setLoading, inspectionDetails },
  }
}

export const putWhatsappSharePdfSuccess = inspectionDetails => ({
  type: PUT_WHATSAPP_SHARE_PDF_SUCCESS,
  payload: inspectionDetails,
})

export const putWhatsappSharePdfFail = error => ({
  type: PUT_WHATSAPP_SHARE_PDF_FAIL,
  payload: error,
})
